import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const blogsApi = createApi({
  reducerPath: 'blogs',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://nfbe.pages.dev/',
  }),
  endpoints(builder) {
    return {
      fetchBlogPostCard: builder.query({
        query: () => ({
          url: 'get-blogCards',
          params: {
          },
          method: 'GET',
        }),
      }),
      fetchBlogPostContent: builder.query({
        // Fetch a specific blog post by ID
        query: (id) => ({
          url: `get-blogs?id=${id}`,
          method: 'GET',
        }),
      }),
    };
  },
});

export const { useFetchBlogPostCardQuery, useFetchBlogPostContentQuery } = blogsApi;
export { blogsApi };
